<template>
  <div class="labour-hour-tab">
    <!-- Query Area -->
    <div class="lh-query">
      <div class="lh-query-title">Labour Hour Creation Duration：</div>
      <div class="lh-query-row">
        <div class="lh-query-group">
          <span class="lh-query-group-title">Year/Quarter</span>
          <el-select clearable multiple size="small" v-model="yearValues" placeholder="Year" style="width:230px">
            <el-option v-for="y in yearList" :key="y" :label="y" :value="y"></el-option>
          </el-select>
          <el-select clearable multiple size="small" v-model="quarterValues" placeholder="Quarter" style="width:260px">
            <el-option v-for="q in quarterList" :key="q" :label="q" :value="q"></el-option>
          </el-select>
          <el-button type="primary" size="small" @click="searchByQuarter" style="margin-left: 10px">Search</el-button>
          <el-button size="small" @click="resetByQuarter">Reset</el-button>
          <el-button size="small" :loading="exportLoading" @click="handleExportByQuarter">Export</el-button>
        </div>
        <div class="lh-query-group">
          <span class="lh-query-group-title">Date</span>
          <el-date-picker
            clearable
            v-model="dateRange"
            type="daterange"
            range-separator="—"
            start-placeholder="Start Date"
            end-placeholder="End Date"
            style="width:230px"
            size="small"
          >
          </el-date-picker>
          <el-button type="primary" size="small" @click="searchByDate">Search</el-button>
          <el-button size="small" @click="resetByDate">Reset</el-button>
          <el-button size="small" :loading="exportLoading" @click="handleExportByDate">Export</el-button>
        </div>
      </div>
    </div>

    <!-- Metric Cards Row 1: Total = Order + Others -->
    <el-row :gutter="16" class="metric-row">
      <el-col :span="8">
        <div class="metric-card metric-total">
          <div class="metric-label">Total Labour Hour</div>
          <div class="metric-value-inline">{{ metrics.total }} <span class="metric-unit-inline">Hours</span></div>
          <div class="metric-formula">= Order Labour Hour + Others</div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="metric-card metric-part">
          <div class="metric-label">Order Labour Hour</div>
          <div class="metric-value-inline">{{ metrics.order }} <span class="metric-unit-inline">Hours</span></div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="metric-card metric-part">
          <div class="metric-label">Others</div>
          <div class="metric-value-inline">{{ metrics.others }} <span class="metric-unit-inline">Hours</span></div>
        </div>
      </el-col>
    </el-row>

    <!-- Metric Cards Row 2 -->
    <el-row :gutter="16" class="metric-row">
      <el-col :span="8">
        <div class="metric-card metric-detail">
          <div class="metric-label">Major Project Mgmt Labour Hour</div>
          <div class="metric-value-inline">{{ metrics.majorProject }} <span class="metric-unit-inline">Hours</span></div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="metric-card metric-detail">
          <div class="metric-label">POC Labour Hour</div>
          <div class="metric-value-inline">{{ metrics.poc }} <span class="metric-unit-inline">Hours</span></div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="metric-card metric-detail">
          <div class="metric-label">Warranty Labour Hour</div>
          <div class="metric-value-inline">{{ metrics.warranty }} <span class="metric-unit-inline">Hours</span></div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'LabourHourTab',
  props: {
    accountInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      // Query - Year/Quarter
      yearValues: [],
      quarterValues: [],
      yearList: (() => {
        const current = new Date().getFullYear()
        const list = []
        for (let y = 2024; y <= current; y++) list.push(String(y))
        return list
      })(),
      quarterList: ['Q1', 'Q2', 'Q3', 'Q4'],
      // Query - Date
      dateRange: null,
      // Export
      exportLoading: false,
      // Metric cards
      metrics: {
        total: 0,
        order: 0,
        others: 0,
        majorProject: 0,
        poc: 0,
        warranty: 0,
      },
    }
  },
  watch: {
    'accountInfo.id'(val) {
      if (val) {
        this.loadMetrics()
      }
    }
  },
  created() {
    if (this.accountInfo.id) {
      this.loadMetrics()
    }
  },
  methods: {
    buildQueryParams(mode) {
      const params = {}
      if (mode === 'quarter') {
        if (this.yearValues.length > 0) params.year = this.yearValues
        if (this.quarterValues.length > 0) params.quarter = this.quarterValues
      } else if (mode === 'date') {
        if (this.dateRange && this.dateRange.length === 2) {
          params.startDate = moment(this.dateRange[0]).format('YYYY-MM-DD')
          params.endDate = moment(this.dateRange[1]).format('YYYY-MM-DD')
        }
      }
      return params
    },
    buildQueryString(params) {
      const parts = []
      Object.keys(params).forEach(key => {
        const val = params[key]
        if (val === undefined || val === null || val === '') return
        if (Array.isArray(val)) {
          parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(val.join(','))}`)
        } else {
          parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(val)}`)
        }
      })
      return parts.join('&')
    },
    loadMetrics(mode) {
      const id = this.accountInfo.id
      if (!id) return
      const params = this.buildQueryParams(mode)
      const qs = this.buildQueryString(params)
      let url = `${this.$store.state.islhurl}valued-account/business/${id}/labour-hour`
      if (qs) url += '?' + qs
      this._get(url).then(res => {
        if (res.code === 200 && res.data) {
          this.metrics = {
            total: res.data.totalLabourHour || 0,
            order: res.data.orderLabourHour || 0,
            others: res.data.othersLabourHour || 0,
            majorProject: res.data.majorProjectMgmtHour || 0,
            poc: res.data.pocLabourHour || 0,
            warranty: res.data.warrantyLabourHour || 0,
          }
        }
      }).catch(() => {})
    },
    searchByQuarter() {
      this.loadMetrics('quarter')
    },
    resetByQuarter() {
      this.yearValues = []
      this.quarterValues = []
      this.loadMetrics()
    },
    searchByDate() {
      this.loadMetrics('date')
    },
    resetByDate() {
      this.dateRange = null
      this.loadMetrics()
    },
    doExport(mode) {
      const id = this.accountInfo.id
      if (!id) {
        this.$message.warning('No account selected')
        return
      }
      this.exportLoading = true
      const params = this.buildQueryParams(mode)
      const qs = this.buildQueryString(params)
      let url = `${this.$store.state.islhurl}valued-account/business/${id}/labour-hour/export`
      if (qs) url += '?' + qs
      this.$axios({
        url,
        method: 'get',
        responseType: 'blob'
      }).then(response => {
        const data = response.data
        if (data.type && data.type.includes('application/json')) {
          const reader = new FileReader()
          reader.onload = () => {
            try {
              const err = JSON.parse(reader.result)
              this.$message.error(err.msg || 'Export failed!')
            } catch (e) {
              this.$message.error('Export failed!')
            }
          }
          reader.readAsText(data)
          return
        }
        const fileName = 'LabourHour_' + moment().format('YYYYMMDDHHmmss') + '.xlsx'
        const blob = new Blob([data])
        const aEle = document.createElement('a')
        const href = window.URL.createObjectURL(blob)
        aEle.href = href
        aEle.download = fileName
        document.body.appendChild(aEle)
        aEle.click()
        document.body.removeChild(aEle)
        window.URL.revokeObjectURL(href)
      }).catch(() => {
        this.$message.error('Export failed!')
      }).finally(() => {
        this.exportLoading = false
      })
    },
    handleExportByQuarter() {
      this.doExport('quarter')
    },
    handleExportByDate() {
      this.doExport('date')
    },
  },
}
</script>

<style lang="less" scoped>
.labour-hour-tab {
  .lh-query {
    padding: 12px 0px 5px 0;
  }
  .lh-query-title {
    font-size: 14px;
    color: #1F2937;
    font-weight: 600;
    margin-bottom: 18px;
  }
  .lh-query-row {
    // display: flex;
    // align-items: center;
    // gap: 12px;
    // flex-wrap: wrap;
  }
  .lh-query-group {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    margin-bottom: 15px;
  }
  .lh-divider {
    display: inline-flex;
    align-items: center;
    margin: 0 4px;
    &::before {
      content: '';
      width: 2px;
      height: 28px;
      background: #007AFF;
      border-radius: 1px;
    }
  }
  .lh-query-group-title {
    width: 80px;
    font-size: 13px;
    color: #1F2937;
    font-weight: 600;
    white-space: nowrap;
    margin-right: 4px;
  }
  .metric-row {
    margin-bottom: 16px;
    display: flex;
    flex-wrap: wrap;
    &::after {
      display: none;
    }
    /deep/ .el-col {
      display: flex;
      float: none;
    }
  }
  .metric-card {
    flex: 1;
    background: #fff;
    border: 1px solid #E5E7EB;
    border-radius: 6px;
    padding: 20px 24px;
    box-shadow: 0 1px 4px rgba(0,0,0,0.04);
    transition: box-shadow 0.15s;
    &:hover {
      box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    }
  }
  .metric-total {
    border-left: 3px solid #007AFF;
  }
  .metric-part {
    border-left: 3px solid #52C41A;
  }
  .metric-detail {
    border-left: 3px solid #FAAD14;
  }
  .metric-label {
    font-size: 13px;
    color: #6B7280;
    margin-bottom: 8px;
    font-weight: 600;
  }
  .metric-value-inline {
    font-size: 28px;
    font-weight: 600;
    color: #1F2937;
    line-height: 1;
  }
  .metric-unit-inline {
    font-size: 12px;
    color: #6B7280;
    font-weight: 400;
  }
  .metric-formula {
    font-size: 12px;
    color: #007AFF;
    margin-top: 6px;
    font-style: italic;
  }
}
.el-button+.el-button, .el-checkbox.is-bordered+.el-checkbox.is-bordered {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/valuedAccountManagement/accountDetailTabs/LabourHour.vue